// Debugging confirmation
console.log('✅ utils-local-storage.js loaded successfully!');

// Save data to localStorage
export function saveToLocalStorage(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error(`❌ Failed to save ${key} to local storage:`, e);
  }
}

/**
 * Safely check if localStorage is available
 */
function isLocalStorageAvailable() {
  try {
    return typeof localStorage !== 'undefined';
  } catch (error) {
    return false;
  }
}

// Load data from localStorage
export function loadFromLocalStorage(key) {
  if (!isLocalStorageAvailable()) {
    console.warn(`⚠️ LocalStorage is not available when trying to load: ${key}`);
    return null;
  }

  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (e) {
    console.error(`❌ Failed to load ${key} from local storage:`, e);
    return null;
  }
}

// Remove data from localStorage
export function removeFromLocalStorage(key) {
  if (!isLocalStorageAvailable()) {
    console.warn(`⚠️ LocalStorage is not available when trying to save: ${key}`);
    return;
  }

  if (!isLocalStorageAvailable()) {
    console.warn(`⚠️ LocalStorage is not available when trying to save: ${key}`);
    return;
  }

  try {
    localStorage.removeItem(key);
    console.log(`✅ Successfully removed ${key} from local storage.`);
  } catch (e) {
    console.error(`❌ Failed to remove ${key} from local storage:`, e);
  }
}

// Other utility functions

// Save an item to a list with a maximum limit and expiry time

export function saveToLocalStorageWithLimitAndExpiry(
  key,
  newItem,
  maxItems = 3,
  expiryDuration = 7 * 24 * 60 * 60 * 1000,
  idKey = 'id'
) {
  if (!isLocalStorageAvailable()) {
    console.warn(`⚠️ LocalStorage is not available when trying to save: ${key}`);
    return;
  }

  try {
    // Load existing list from localStorage
    let itemList = loadFromLocalStorage(key) || [];

    // Get the current timestamp
    const timestamp = Date.now();

    // Check if the item already exists and remove it based on the dynamic ID key
    itemList = itemList.filter(item => item[idKey] !== newItem[idKey]);

    // Add the new item with an expiry timestamp
    newItem.expiry = timestamp + expiryDuration;
    itemList.unshift(newItem);

    // Limit the list to the maximum number of items
    if (itemList.length > maxItems) {
      itemList = itemList.slice(0, maxItems);
    }

    // Save the updated list back to localStorage
    localStorage.setItem(key, JSON.stringify(itemList));
    console.log(
      `✅ Saved to local storage with limit (${maxItems}), expiry, and key [${idKey}]:`,
      newItem
    );
  } catch (e) {
    console.error(`❌ Failed to save ${key} with limit and expiry to local storage:`, e);
  }
}

//export function saveToLocalStorageWithLimitAndExpiry(key, newItem, maxItems = 3, expiryDuration = 7 * 24 * 60 * 60 * 1000) {

//    if (!isLocalStorageAvailable()) {
//        console.warn(`⚠️ LocalStorage is not available when trying to save: ${key}`);
//        return;
//    }

//    try {
//        // Load existing list from localStorage
//        let itemList = loadFromLocalStorage(key) || [];

//        // Get the current timestamp
//        const timestamp = Date.now();

//        // Check if the item already exists and remove it (by ID)
//        itemList = itemList.filter(item => item.id !== newItem.id);

//        // Add the new item with an expiry timestamp
//        newItem.expiry = timestamp + expiryDuration;
//        itemList.unshift(newItem);

//        // Limit the list to the maximum number of items
//        if (itemList.length > maxItems) {
//            itemList = itemList.slice(0, maxItems);
//        }

//        // Save the updated list back to localStorage
//        localStorage.setItem(key, JSON.stringify(itemList));
//        console.log(`✅ Saved to local storage with limit (${maxItems}) and expiry:`, newItem);
//    } catch (e) {
//        console.error(`❌ Failed to save ${key} with limit and expiry to local storage:`, e);
//    }
//}

// Load items from localStorage, removing expired ones
export function loadFromLocalStorageWithExpiry(key) {
  if (!isLocalStorageAvailable()) {
    console.warn(`⚠️ LocalStorage is not available when trying to save: ${key}`);
    return;
  }

  try {
    const itemList = loadFromLocalStorage(key) || [];
    const now = Date.now();

    // Filter out expired items
    const validItems = itemList.filter(item => !item.expiry || item.expiry > now);

    // If expired items were removed, update localStorage
    if (validItems.length !== itemList.length) {
      localStorage.setItem(key, JSON.stringify(validItems));
      console.log('♻️ Removed expired items from local storage.');
    }

    return validItems;
  } catch (e) {
    console.error(`❌ Failed to load ${key} from local storage:`, e);
    return [];
  }
}
